<div class="modal-box modal_box">
  <div class="modal_header bg_primary_light">
    <a class="btnn close_btn" mat-dialog-close>
      <mat-icon>{{ 'close' | translate }}</mat-icon>
    </a>
    <figure>
      <img [src]="assetsConst.Logo" alt="logo" />
    </figure>
  </div>
  <div class="modal_body">
    <div class="modal_subtitle">
      <h3>{{ 'resetPassword' | translate }}</h3>
      <p>{{ 'setPassword' | translate }}</p>
    </div>
    <form
      [formGroup]="resetPasswordFormGroup"
      (ngSubmit)="onSubmit()"
      class="tab_content">
      <div class="form_field gap_m">
        <div class="form_group">
          <mat-form-field>
            <input
              matInput
              [placeholder]="'enterNewPassword' | translate"
              class="form_control"
              [type]="hiddenNewPasswordVisibility ? 'password' : 'text'"
              formControlName="newPassword" />
          </mat-form-field>
          <span
            (click)="hiddenNewPasswordVisibility = !hiddenNewPasswordVisibility"
            class="pass_ico">
            <mat-icon>{{
              !hiddenNewPasswordVisibility ? 'visibility' : 'visibility_off'
            }}</mat-icon>
          </span>
          <mat-error
            *ngIf="
              submitted &&
              resetPasswordFormGroup.controls['newPassword'].hasError(
                'required'
              )
            ">
            {{ 'Password' | translate }} {{ 'isRequired' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              resetPasswordFormGroup.controls['newPassword'].hasError('pattern')
            ">
            <ul>
              <li
                *ngFor="let err of formErrors"
                [ngClass]="{
                  greenClass: checkValidations(
                    resetPasswordFormGroup.controls['newPassword'],
                    err.key
                  ),
                  redClass: !checkValidations(
                    resetPasswordFormGroup.controls['newPassword'],
                    err.key
                  )
                }"></li>
            </ul>
          </mat-error>
        </div>

        <div class="form_group">
          <mat-form-field>
            <input
              matInput
              [placeholder]="'enterconfirmPassword' | translate"
              class="form_control"
              [type]="hiddenConfirmPasswordVisibility ? 'password' : 'text'"
              formControlName="confirmPassword" />
          </mat-form-field>
          <span
            (click)="
              hiddenConfirmPasswordVisibility = !hiddenConfirmPasswordVisibility
            "
            class="pass_ico">
            <mat-icon>{{
              !hiddenConfirmPasswordVisibility ? 'visibility' : 'visibility_off'
            }}</mat-icon>
          </span>
          <mat-error
            *ngIf="
              submitted &&
              resetPasswordFormGroup.controls['confirmPassword'].hasError(
                'required'
              )
            ">
            {{ 'confirmPassword' | translate }} {{ 'isRequired' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              submitted &&
              resetPasswordFormGroup.controls['confirmPassword']?.hasError(
                'mustMatch'
              )
            ">
            {{ 'PasswordMatch' | translate }}
          </mat-error>
        </div>

        <div class="submit_btn mt_20">
          <button class="btnn btn_primary" type="submit">
            {{ 'updatePassword' | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
